<template>
  <div class="flex flex-col gap-2 w-60">
    <button class="btn-dark-button" @click="recalculatePaidOrdersLocal()">
      <template v-if="!recalculatingPayments">
        Recalculate Paid orders
      </template>
      <template v-else>
        Recalculating....
      </template>
    </button>
    <button class="btn-dark-button mt-4" @click="recalculatePopularityLocal()">
      <template v-if="!recalculatingPopularProducts">
        Recalculate Popularity
      </template>
      <template v-else>
        Recalculating....
      </template>
    </button>
    <button class="btn-dark-button mt-4" @click="sendAllCustomersToEscala()">
      <template v-if="!sendingAllCustomersToEscala">
        Send all Customers to Escala
      </template>
      <template v-else>
        Requesting....
      </template>
    </button>
    <button
      class="btn-dark-button mt-4"
      @click="updateShipstationCarriersAndServices()"
    >
      <template v-if="!shipstationCarriersAndServices">
        Update shipstation carriers and services
      </template>
      <template v-else>
        Requesting....
      </template>
    </button>
    <!-- create missing titles -->
    <button class="btn-dark-button mt-4" @click="copyTitlesFromInfoauto()">
      <template v-if="!creatingMissingTitles">
        Copy missing titles from Infoauto
      </template>
      <template v-else>
        Requesting....
      </template>
    </button>
    <!-- rebuild orders search index/list_metadata (used by /orders) -->
    <button
      class="btn-dark-button mt-4"
      @click="backfillOrdersSearchIndexLocal()"
    >
      <template v-if="!backfillingOrdersSearchIndex">
        Rebuild orders search index
      </template>
      <template v-else>
        Rebuilding....
      </template>
    </button>
  </div>
</template>
<script>
import {
  recalculatePaidOrders as recalculatePaidOrdersApi,
  backfillOrdersSearchIndex
} from "@/api/store/OrdersService.js";
import { recalculatePopularity } from "@/api/store/PopularProductsService";
import { sendAllCustomersToEscala as sendAllCustomersToEscalaApi } from "@/api/store/EscalaService";
import { updateShipstationCarriersAndServices as updateShipstationCarriersAndServicesApi } from "@/api/store/ShipstationService";
import { copyTitlesFromInfoauto } from "@/api/store/ProductsService";
export default {
  data() {
    return {
      recalculatingPayments: false,
      recalculatingPopularProducts: false,
      sendingAllCustomersToEscala: false,
      shipstationCarriersAndServices: false,
      creatingMissingTitles: false,
      backfillingOrdersSearchIndex: false
    };
  },
  methods: {
    recalculatePaidOrdersLocal() {
      if (!this.recalculatingPayments) {
        this.recalculatingPayments = true;
        recalculatePaidOrdersApi()
          .then(() => {
            this.$toast.open({
              message: `Payments recalculated`,
              type: "success",
              position: "top-right"
            });
          })
          .catch(() => {
            this.$toast.open({
              message: `Error recalculating payments`,
              type: "error",
              position: "top-right"
            });
          })
          .finally(() => {
            this.recalculatingPayments = false;
          });
      }
    },
    recalculatePopularityLocal() {
      if (!this.recalculatingPopularProducts) {
        this.recalculatingPopularProducts = true;
        recalculatePopularity()
          .then(response => {
            console.log(response);
            this.$toast.open({
              message: response,
              type: "success",
              position: "top-right"
            });
          })
          .catch(() => {
            this.$toast.open({
              message: `Error recalculating popularity`,
              type: "error",
              position: "top-right"
            });
          })
          .finally(() => {
            this.recalculatingPopularProducts = false;
          });
      }
    },
    sendAllCustomersToEscala() {
      this.sendingAllCustomersToEscala = true;
      sendAllCustomersToEscalaApi()
        .then(() => {
          this.$toast.open({
            message: `Sending customers to escala`,
            type: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$toast.open({
            message: `Error sending customers to escala`,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.sendingAllCustomersToEscala = false;
        });
    },
    updateShipstationCarriersAndServices() {
      this.shipstationCarriersAndServices = true;
      updateShipstationCarriersAndServicesApi()
        .then(() => {
          this.$toast.open({
            message: `Updated shipstation carriers and services`,
            type: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$toast.open({
            message: `Error updating shipstation carriers and services`,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.shipstationCarriersAndServices = false;
        });
    },
    copyTitlesFromInfoauto() {
      if (this.creatingMissingTitles) {
        return;
      }
      this.creatingMissingTitles = true;
      copyTitlesFromInfoauto()
        .then(res => {
          console.log(res);
          this.$toast.open({
            message: res.message,
            type: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$toast.open({
            message: `Error copying titles from Infoauto`,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.creatingMissingTitles = false;
        });
    },
    backfillOrdersSearchIndexLocal() {
      if (this.backfillingOrdersSearchIndex) {
        return;
      }
      this.backfillingOrdersSearchIndex = true;
      backfillOrdersSearchIndex()
        .then(res => {
          this.$toast.open({
            message: `Orders search index rebuilt: ${res.updated} updated, ${res.remaining} remaining`,
            type: res.done ? "success" : "info",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$toast.open({
            message: `Error rebuilding orders search index`,
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.backfillingOrdersSearchIndex = false;
        });
    }
  }
};
</script>
